import React from "react";
import styles from "./Features.module.css"; // Importando o CSS

import {
  Calculator,
  Settings,
  Package,
  Truck,
  DollarSign,
  Calendar,
  Users,
  Database,
  FileText
} from "lucide-react";

const features = [
  {
    icon: Calculator,
    title: "Orçamentos",
    description:
      "Crie orçamentos precisos e profissionais com cálculos automáticos de custos, materiais e mão de obra. Acompanhe aprovações e conversões em tempo real.",
    color: "blue"
  },
  {
    icon: Settings,
    title: "Produção",
    description:
      "Controle total do processo produtivo, desde o planejamento até a entrega. Monitore etapas, qualidade e prazos com dashboards intuitivos.",
    color: "#53a535"
  },
  {
    icon: Package,
    title: "Produtos",
    description:
      "Gerencie seu catálogo de produtos com especificações técnicas, imagens, variações e histórico de preços. Controle de estoque integrado.",
    color: "purple"
  },
  {
    icon: Truck,
    title: "Fornecedores",
    description:
      "Cadastro completo de fornecedores com histórico de compras, avaliações de desempenho e gestão de contratos e prazos de pagamento.",
    color: "orange"
  },
  {
    icon: DollarSign,
    title: "Custo Fixo",
    description:
      "Controle de todos os custos fixos da operação. Rateio automático por produto e centro de custo para precificação precisa.",
    color: "green"
  },
  {
    icon: Calendar,
    title: "Planejamento",
    description:
      "Planejamento de produção com cronogramas, alocação de recursos e previsões. Otimize sua capacidade produtiva e cumpra prazos.",
    color: "indigo"
  },
  {
    icon: Users,
    title: "Pessoas",
    description:
      "Gestão completa de colaboradores, cargos, salários e produtividade. Controle de ponto e relatórios de desempenho integrados.",
    color: "#f727a4"
  },
  {
    icon: Database,
    title: "Cadastros",
    description:
      "Base unificada de dados para clientes, produtos, fornecedores e processos. Informações organizadas e acessíveis para toda a equipe.",
    color: "#97a234ff"
  },
  {
    icon: FileText,
    title: "Nota Fiscal",
    description:
      "Emissão automática de notas fiscais integrada ao sistema. Controle fiscal completo com relatórios e conformidade tributária. (Em desenvolvimento)",
    color: "#c1b721ff",
    badge: "Em Desenvolvimento"
  }
];

const Features = () => {
  return (
    <section id={"features-section"} className={styles["features-section"]}>
      <h2 className={styles["features-title"]}>
        Funcionalidades Completas
      </h2>
      <p className={styles["features-description"]}>
        Todas as ferramentas que sua facção precisa em um só lugar. Desenvolvido
        por quem entende do negócio têxtil.
      </p>

      <div className={styles["features-grid"]}>
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <div
              key={feature.title}
              className={styles["feature-card"]}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center justify-center">
                <div
                  className={`${styles["feature-card-icon"]}`}
                >
                  <Icon size={28} color={feature.color} />
                </div>
              </div>
              <h3 className={styles["feature-card-title"]}>
                {feature.title}
              </h3>
              <p className={styles["feature-card-description"]}>
                {feature.description}
              </p>
              {feature.badge && (
                <span className={styles.badge}>{feature.badge}</span>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Features;
